import { useEffect } from 'react';

import { StyleSheet, ViewStyle } from 'react-native';
import Animated, {
  Easing,
  useAnimatedStyle,
  useSharedValue,
  withRepeat,
  withTiming,
} from 'react-native-reanimated';

import { primitive } from 'styles/constants/primitives';

const SKELETON_ANIMATION_TIMING_VALUE = 0.3;
const SKELETON_ANIMATION_DURATION = 800;
const WITH_LOOP = -1;
const WITH_REVERSE_ANIMATION = true;

interface ISkeletonProps {
  shape?: 'line' | 'rectangle' | 'square' | 'circle';
  style?: ViewStyle;
}

export const Skeleton: React.FC<ISkeletonProps> = ({ shape = 'rectangle', style }) => {
  const opacity = useSharedValue(1);

  useEffect(() => {
    opacity.value = withRepeat(
      withTiming(SKELETON_ANIMATION_TIMING_VALUE, {
        duration: SKELETON_ANIMATION_DURATION,
        easing: Easing.inOut(Easing.ease),
      }),
      WITH_LOOP,
      WITH_REVERSE_ANIMATION
    );
  }, [opacity]);

  const animatedStyle = useAnimatedStyle(() => {
    return {
      opacity: opacity.value,
    };
  });

  const baseStyle: ViewStyle[] = [styles.common, styles[shape], style || {}];

  return <Animated.View style={[baseStyle, animatedStyle]} />;
};

const styles = StyleSheet.create({
  common: {
    backgroundColor: primitive.$blackOpacity10,
    width: '100%',
    marginVertical: 8,
  },
  line: {
    marginVertical: 4,
    height: 10,
    borderRadius: 12,
  },
  rectangle: {
    height: 20,
    borderRadius: 12,
  },
  square: {
    height: 72,
    width: 72,
    borderRadius: 4,
  },
  circle: {
    borderRadius: 50,
    width: 44,
    height: 44,
  },
});
